import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import About from '../views/About.vue'
import Contact from '../views/Contact.vue'
import Signin from "../views/Signin.vue"
import Signup from "../views/Signup.vue"
import Colours from "../views/Colours.vue"
import StandardCalc from "../views/Calc.vue"
import Alphabet from "../views/english/Alphabets.vue"
import EngQuiz from "../views/english/EnglishQuiz/EnglishQuiz.vue"
import WordGame from "../views/english/WordGame/WordGame.vue"
import FindWords from "../views/english/FindWords/FindWords.vue"
import WordSearch from "../views/english/WordSearch/WordSearch.vue"
import Numbers from "../views/maths/Numbers.vue"
import TimesTablesTrainer from "../views/maths/timestables/TimesTablesTrainer.vue"
import FractionsQuiz from "../views/maths/fractions/FractionsQuiz.vue"
import NumberSequence from "../views/maths/numsequence/NumberSequence.vue"
import ShapeRecognition from "../views/maths/shapes/ShapeRecognition.vue"
import ArithmeticOperator from "../views/maths/Operators.vue"
import AddMinus from '../components/addminus.vue'
import TimesDivide from '../components/timesdivide.vue'
import Profile from '../views/Profile.vue'
import * as firebase from 'firebase/app'
import 'firebase/auth'

Vue.use(VueRouter)

const routes = [
  { path: '/', name: 'Home', component: Home },
  { path: '/about', name: 'about', component: About },
  { path: '/contact', name: 'contact', component: Contact },
  { path: "/signin", name: 'signin', component: Signin },
  { path: "/signup", name: 'signup', component: Signup },
  { path: "/colours", name: 'colours', component: Colours, meta: {requiresAuth: true} },
  { path: "/standardCalc", name: 'standardCalc', component: StandardCalc, meta: {requiresAuth: true} },
  // { path: "/alphabets", name: 'alphabet', component: Alphabet, meta: {requiresAuth: true} },
  { path: "/wordGenerator", name: 'engQuiz', component: EngQuiz, meta: {requiresAuth: true} },
  { path: "/missingLetter", name: 'wordGame', component: WordGame, meta: {requiresAuth: true} },
  { path: "/findWords", name: 'findWords', component: FindWords, meta: {requiresAuth: true} },
  { path: "/wordSearch", name: 'wordSearch', component: WordSearch, meta: {requiresAuth: true} },
  { path: "/sortChallenge", name: 'number', component: Numbers, meta: {requiresAuth: true} },
  { path: "/timesTablesTrainer", name: 'timesTablesTrainer', component: TimesTablesTrainer, meta: {requiresAuth: true} },
  { path: "/fractionsQuiz", name: 'fractionsQuiz', component: FractionsQuiz, meta: {requiresAuth: true} },
  { path: "/numberSequence", name: 'numberSequence', component: NumberSequence, meta: {requiresAuth: true} },
  { path: "/shapeRecognition", name: 'shapeRecognition', component: ShapeRecognition, meta: {requiresAuth: true} },
  { path: "/operatorIdentifier", name: 'arithmeticOperator', component: ArithmeticOperator, meta: {requiresAuth: true} },
  { path: "/addMinus", name: 'Addminus', component: AddMinus, meta: {requiresAuth: true} },
  { path: "/timesDivide", name: 'Timesdivide', component: TimesDivide, meta: {requiresAuth: true} },
  { path: "/profile", name: 'profile', component: Profile, meta: {requiresAuth: true} },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
  const isAuthenticated = firebase.auth().currentUser;
  if(requiresAuth && !isAuthenticated) {
    next("/signin");
  } else {
    next();
  }
})

export default router